import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Config} from "../../config/config";

@Component({
    selector: 'db-connect-only',
    templateUrl: './connect-only.component.html',
    styleUrls: ['./connect-only.component.scss'],
    standalone: false
})
export class ConnectOnlyComponent implements OnInit {

  @Input() premiumPlugin;
  @Input() managerLink: string;
  @Output() download: EventEmitter<void> = new EventEmitter<void>();
  @Output() signOut: EventEmitter<void> = new EventEmitter<void>();
  public Config = Config;

  constructor() { }

  ngOnInit() {
  }
}
